import { useEffect, useState } from 'react';
import styles from './css/edit.module.css'
import invoke from "../calllambda"

export default function Edit(props) {
  const [floorcnt, setFloorcnt] = useState(0);
  const [structure, setStructure] = useState({});
  const [alert, setAlert] = useState({});

  useEffect(() => {
    if (props.point?.structure?.floor_height != undefined) {
      setStructure(props.point?.structure);
      setAlert(props.point?.alert);
      setFloorcnt(JSON.parse(props.point?.structure?.floor_height).length + 1);
    } else {
      setFloorcnt(0)
    }
  }, [props.point?.structure, props.point?.alert]);

  function Alert() {
    return <table>
      <tbody>
        <tr>
          <td><label className={styles.section} htmlFor="threseis">震度:</label></td>
          <td>
            <select name="threseis" defaultValue={alert?.thresholds?.earthquake} required>
              <option value={null}>なし</option>
              <option value={0}>全て</option>
              <option value={0.5}>1</option>
              <option value={1.5}>2</option>
              <option value={2.5}>3</option>
              <option value={3.5}>4</option>
              <option value={4.5}>5弱</option>
              <option value={5.0}>5強</option>
              <option value={5.5}>6弱</option>
              <option value={6.0}>6強</option>
              <option value={6.5}>7</option>
            </select>
          </td>
        </tr>
        <tr><td><label className={styles.section} htmlFor="threrain">雨量[mm/h]:</label></td></tr>
        <tr>
          <td><label htmlFor="threrain1">レベル１</label></td>
          <td><input type="number" name="threrain1" defaultValue={alert?.thresholds?.rain1?.value} /></td>
          <td><label htmlFor="txtthrerain1">注意コメント</label></td>
          <td><input type="text" name="txtthrerain1" defaultValue={alert?.thresholds?.rain1?.text} /></td>
        </tr>
        <tr>
          <td><label htmlFor="threrain2">レベル２</label></td>
          <td><input type="number" name="threrain2" defaultValue={alert?.thresholds?.rain2?.value} /></td>
          <td><label htmlFor="txtthrerain2">注意コメント</label></td>
          <td><input type="text" name="txtthrerain2" defaultValue={alert?.thresholds?.rain2?.text} /></td>
        </tr>
        <tr>
          <td><label htmlFor="threrain3">レベル３</label></td>
          <td><input type="number" name="threrain3" defaultValue={alert?.thresholds?.rain3?.value} /></td>
          <td><label htmlFor="txtthrerain3">注意コメント</label></td>
          <td><input type="text" name="txtthrerain3" defaultValue={alert?.thresholds?.rain3?.text} /></td>
        </tr>
        <tr>
          <td><label htmlFor="minrain">休止時間[分]:</label></td>
          <td><input type="number" name="minrain" defaultValue={alert?.interval?.rain} /></td>
        </tr>
        <tr><td><label className={styles.section} htmlFor="threwind">風速[m/s]:</label></td></tr>
        <tr>
          <td><label htmlFor="threwind1">レベル１</label></td>
          <td><input type="number" name="threwind1" defaultValue={alert?.thresholds?.wind1?.value} /></td>
          <td><label htmlFor="txtthrewind1">注意コメント</label></td>
          <td><input type="text" name="txtthrewind1" defaultValue={alert?.thresholds?.wind1?.text} /></td>
        </tr>
        <tr>
          <td><label htmlFor="threwind2">レベル２</label></td>
          <td><input type="number" name="threwind2" defaultValue={alert?.thresholds?.wind2?.value} /></td>
          <td><label htmlFor="txtthrewind2">注意コメント</label></td>
          <td><input type="text" name="txtthrewind2" defaultValue={alert?.thresholds?.wind2?.text} /></td>
        </tr>
        <tr>
          <td><label htmlFor="threwind3">レベル３</label></td>
          <td><input type="number" name="threwind3" defaultValue={alert?.thresholds?.wind3?.value} /></td>
          <td><label htmlFor="txtthrewind3">注意コメント</label></td>
          <td><input type="text" name="txtthrewind3" defaultValue={alert?.thresholds?.wind3?.text} /></td>
        </tr>
        <tr>
          <td><label htmlFor="minwind">休止時間[分]:</label></td>
          <td><input type="number" name="minwind" defaultValue={alert?.interval?.wind} /></td>
        </tr>
        <tr>
          <td><label className={styles.section} htmlFor="mails">メール:</label></td>
        </tr>
        <Mails mails={alert?.mail} />
      </tbody>
    </table>
  }

  function Mails(props) {
    const [list, setlist] = useState(props.mails);
    const [line, setLine] = useState([])
    var lastemptycnt = 0;
    function updatelist() {
      var mails = [];
      for (var i = 0; true; i++) {
        if (document.getElementsByName("mail_" + i).length <= 0) break;
        var txt = gettext("mail_" + i);
        mails.push(txt);
        if (txt != "") {
          lastemptycnt = 0;
        } else {
          lastemptycnt++;
        }
      }
      mails = mails.slice(0, mails.length - lastemptycnt);
      setlist(mails);
    }

    useEffect(() => {
      var aline = [];
      for (var i = 0; i <= list?.length / 2; i++) {
        aline.push(
          <tr key={i}>
            <td colSpan={2}><input type="email" name={"mail_" + (i * 2)} defaultValue={list?.length >= i * 2 ? list[i * 2] : ""} style={{ width: "100%" }} onChange={(e) => { updatelist() }} /></td>
            <td colSpan={2}><input type="email" name={"mail_" + (i * 2 + 1)} defaultValue={list?.length >= i * 2 + 1 ? list[i * 2 + 1] : ""} style={{ width: "100%" }} onChange={(e) => { updatelist() }} /></td>
          </tr>
        )
      }
      setLine(aline);
    }, [list]);

    return <>{line}</>
  }

  function Stimulas() {
    var x = [], y = [], z = [], keys = [];
    const matrixcnt = floorcnt - 1;
    if (structure?.stimulus != undefined) {
      var astim = JSON.parse(structure?.stimulus)
      for (var i = 0; i < matrixcnt; i++) {
        var xline = [];
        var yline = [];
        //var zline = [];  
        for (var j = 0; j < matrixcnt; j++) {
          xline.push(<td key={"x" + j}><input type="text" name={"stimx_" + j + "_" + i} defaultValue={astim["x"][i][j]} /></td>);
          yline.push(<td key={"y" + j}><input type="text" name={"stimy_" + j + "_" + i} defaultValue={astim["y"][i][j]} /></td>);
          //zline.push(<td><input type="text" name={"stimz_" + j + "_" + i} defaultValue={astim["z"][i][j]} /></td>);
        }
        x.push(<tr key={"x" + i + "_" + j}>{xline}</tr>);
        y.push(<tr key={"y" + i + "_" + j}>{yline}</tr>);
        //z.push(<tr>
        keys.push(i);
      }
    }
    //return <table><tbody><tr><td>x:</td></tr>{x}<tr><td>y:</td></tr>{y}<td>z:</td></tr>{z}</tbody></table>
    return <table><tbody><tr><td>x:</td></tr>{x}<tr><td>y:</td></tr>{y}</tbody></table>
  }

  function Threshold() {
    var list = [];
    if (structure?.damage_threshold != undefined) {
      var athre = JSON.parse(structure?.damage_threshold)
      list.push(<tr key={"ti0"}><td colSpan={6}><span className={styles.section}>フロア表示名称</span></td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"f" + i} >
            <td><label>フロア{i + 1}</label></td>
            <td><input type="text" name={"floorname_" + i} defaultValue={athre[i]?.floor} /></td>
          </tr>
        );
      }
      list.push(<tr key={"br1"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti1"}><td colSpan={6}><span className={styles.section}>躯体:X[1/rad]</span></td></tr>)
      list.push(<tr key={"hd1"} align="center"><td></td><td>注意</td><td>危険</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"x" + i}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"bodx1_" + i} defaultValue={athre[i]?.body_x?.value[0]} /></td>
            <td><input type="number" name={"bodx2_" + i} defaultValue={athre[i]?.body_x?.value[1]} /></td>
          </tr>
        );
      }
      list.push(<tr key={"br2"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti2"}><td colSpan={6}><span className={styles.section}>躯体:Y[1/rad]</span></td></tr>)
      list.push(<tr key={"hd2"} align="center"><td></td><td>注意</td><td>危険</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"y" + i}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"body1_" + i} defaultValue={athre[i]?.body_y?.value[0]} /></td>
            <td><input type="number" name={"body2_" + i} defaultValue={athre[i]?.body_y?.value[1]} /></td>
          </tr>
        );
      }
      list.push(<tr key={"br3"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti3"}><td colSpan={6}><span className={styles.section}>外装[1/rad]</span></td></tr>)
      list.push(<tr key={"hd3"} align="center"><td></td><td>注意</td><td>注意コメント</td><td>危険</td><td>危険コメント</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"ex" + i}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"wall1_" + i} defaultValue={athre[i]?.wall?.value[0]} /></td>
            <td><input type="text" name={"txtwall1_" + i} defaultValue={athre[i]?.wall?.text[0]} /></td>
            <td><input type="number" name={"wall2_" + i} defaultValue={athre[i]?.wall?.value[1]} /></td>
            <td><input type="text" name={"txtwall2_" + i} defaultValue={athre[i]?.wall?.text[1]} /></td>
          </tr>
        );
      }
      list.push(<tr key={"br4"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti4"}><td colSpan={6}><span className={styles.section}>間仕切壁[1/rad]</span></td></tr>)
      list.push(<tr key={"hd4"} align="center"><td></td><td>注意</td><td>注意コメント</td><td>危険</td><td>危険コメント</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"w" + i}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"part1_" + i} defaultValue={athre[i]?.partition?.value[0]} /></td>
            <td><input type="text" name={"txtpart1_" + i} defaultValue={athre[i]?.partition?.text[0]} /></td>
            <td><input type="number" name={"part2_" + i} defaultValue={athre[i]?.partition?.value[1]} /></td>
            <td><input type="text" name={"txtpart2_" + i} defaultValue={athre[i]?.partition?.text[1]} /></td>
          </tr>
        )
      }
      list.push(<tr key={"br5"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti5"}><td colSpan={6}><span className={styles.section}>天井[gal]</span></td></tr>)
      list.push(<tr key={"hd5"} align="center"><td></td><td>注意</td><td>注意コメント</td><td>危険</td><td>危険コメント</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"c" + i}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"ceiling1_" + i} defaultValue={athre[i]?.ceiling?.value[0]} /></td>
            <td><input type="text" name={"txtceiling1_" + i} defaultValue={athre[i]?.ceiling?.text[0]} /></td>
            <td><input type="number" name={"ceiling2_" + i} defaultValue={athre[i]?.ceiling?.value[1]} /></td>
            <td><input type="text" name={"txtceiling2_" + i} defaultValue={athre[i]?.ceiling?.text[1]} /></td>
          </tr>
        )
      }
      list.push(<tr key={"br6"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti6"}><td colSpan={6}><span className={styles.section}>設備機器[gal]</span></td></tr>)
      list.push(<tr key={"hd6"} align="center"><td></td><td>注意</td><td>注意コメント</td><td>危険</td><td>危険コメント</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"eq" + i}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"equip1_" + i} defaultValue={athre[i]?.equipment?.value[0]} /></td>
            <td><input type="text" name={"txtequip1_" + i} defaultValue={athre[i]?.equipment?.text[0]} /></td>
            <td><input type="number" name={"equip2_" + i} defaultValue={athre[i]?.equipment?.value[1]} /></td>
            <td><input type="text" name={"txtequip2_" + i} defaultValue={athre[i]?.equipment?.text[1]} /></td>
          </tr>
        )
      }
      list.push(<tr key={"br7"}><td>&nbsp;</td></tr>);
      list.push(<tr key={"ti7"}><td colSpan={6}><span className={styles.section}>免震[mm]</span></td></tr>)
      list.push(<tr key={"hd7"} align="center"><td></td><td>注意</td><td>危険</td></tr>)
      for (var i = floorcnt - 1; i >= 0; i--) {
        list.push(
          <tr key={"i" + i} style={{ display: i > 0 ? "none" : "" }}>
            <td><label>フロア{i + 1}</label></td>
            <td><input type="number" name={"seisiso1_" + i} defaultValue={athre[i]?.seisisolator?.value[0]} /></td>
            <td><input type="number" name={"seisiso2_" + i} defaultValue={athre[i]?.seisisolator?.value[1]} /></td>
          </tr>
        );
      }
    }
    return <table className={styles.table}><tbody>{list}</tbody></table>
  }

  async function save() {
    //alert
    var aalert = { "thresholds": {}, "interval": {}, "mail": [] };
    aalert["thresholds"]["earthquake"] = getnumber('threseis');
    aalert["thresholds"]["rain1"] = { "value": getnumber('threrain1'), "text": gettext('txtthrerain1') };
    aalert["thresholds"]["rain2"] = { "value": getnumber('threrain2'), "text": gettext('txtthrerain2') };
    aalert["thresholds"]["rain3"] = { "value": getnumber('threrain3'), "text": gettext('txtthrerain3') };
    aalert["thresholds"]["wind1"] = { "value": getnumber('threwind1'), "text": gettext('txtthrewind1') };
    aalert["thresholds"]["wind2"] = { "value": getnumber('threwind2'), "text": gettext('txtthrewind2') };
    aalert["thresholds"]["wind3"] = { "value": getnumber('threwind3'), "text": gettext('txtthrewind3') };
    aalert["interval"]["rain"] = getnumber('minrain');
    aalert["interval"]["wind"] = getnumber('minwind');
    var mails = [];
    for (var i = 0; true; i++) {
      if (document.getElementsByName("mail_" + i).length <= 0) break;
      var mail = gettext("mail_" + i);
      if (mail != "") mails.push(mail);
    }
    aalert["mail"] = mails;
    //stimulus
    var astimulus = { "x": [], "y": [], "z": [] };
    for (var i = 0; i < floorcnt - 1; i++) {
      var xline = [], yline = [], zline = [];
      for (var j = 0; j < floorcnt - 1; j++) {
        var x = getnumber("stimx_" + j + "_" + i);
        var y = getnumber("stimy_" + j + "_" + i);
        //var z = getnumber("stimz_" + j + "_" + i);
        x = x=="" ? 0 : x
        y = y=="" ? 0 : y
        xline.push(x);
        yline.push(y);
        //if (z != null) zline.push(z);
        zline.push(y);//zは入力せず、仮にy
      }
      astimulus["x"].push(xline);
      astimulus["y"].push(yline);
      astimulus["z"].push(zline);
    }


    //threshold
    var athreshold = []
    for (var i = 0; i < floorcnt; i++) {
      var onefloor = { "floor": "", "body_x": { "value": [0, 0] }, "body_y": { "value": [0, 0] }, "wall": { "value": [0, 0], "text": ["", ""] }, "partition": { "value": [0, 0], "text": ["", ""] }, "ceiling": { "value": [0, 0], "text": ["", ""] }, "equipment": { "value": [0, 0], "text": ["", ""] }, "seisisolator": { "value": [0, 0] } }
      onefloor["floor"] = gettext("floorname_" + i);
      onefloor["body_x"]["value"][0] = getnumber("bodx1_" + i);
      onefloor["body_x"]["value"][1] = getnumber("bodx2_" + i);
      onefloor["body_y"]["value"][0] = getnumber("body1_" + i);
      onefloor["body_y"]["value"][1] = getnumber("body2_" + i);
      onefloor["wall"]["value"][0] = getnumber("wall1_" + i);
      onefloor["wall"]["value"][1] = getnumber("wall2_" + i);
      onefloor["wall"]["text"][0] = gettext("txtwall1_" + i);
      onefloor["wall"]["text"][1] = gettext("txtwall2_" + i);
      onefloor["partition"]["value"][0] = getnumber("part1_" + i);
      onefloor["partition"]["value"][1] = getnumber("part2_" + i);
      onefloor["partition"]["text"][0] = gettext("txtpart1_" + i);
      onefloor["partition"]["text"][1] = gettext("txtpart2_" + i);
      onefloor["ceiling"]["value"][0] = getnumber("ceiling1_" + i);
      onefloor["ceiling"]["value"][1] = getnumber("ceiling2_" + i);
      onefloor["ceiling"]["text"][0] = gettext("txtceiling1_" + i);
      onefloor["ceiling"]["text"][1] = gettext("txtceiling2_" + i);
      onefloor["equipment"]["value"][0] = getnumber("equip1_" + i);
      onefloor["equipment"]["value"][1] = getnumber("equip2_" + i);
      onefloor["equipment"]["text"][0] = gettext("txtequip1_" + i);
      onefloor["equipment"]["text"][1] = gettext("txtequip2_" + i);
      onefloor["seisisolator"]["value"][0] = getnumber("seisiso1_" + i);
      onefloor["seisisolator"]["value"][1] = getnumber("seisiso2_" + i);
      if (onefloor["body_x"]["value"][0] == 0 && onefloor["body_x"]["value"][1] == 0) delete onefloor["body_x"];
      if (onefloor["body_y"]["value"][0] == 0 && onefloor["body_y"]["value"][1] == 0) delete onefloor["body_y"];
      if (onefloor["wall"]["value"][0] == 0 && onefloor["wall"]["value"][1] == 0) delete onefloor["wall"];
      if (onefloor["partition"]["value"][0] == 0 && onefloor["partition"]["value"][1] == 0) delete onefloor["partition"];
      if (onefloor["ceiling"]["value"][0] == 0 && onefloor["ceiling"]["value"][1] == 0) delete onefloor["ceiling"];
      if (onefloor["equipment"]["value"][0] == 0 && onefloor["equipment"]["value"][1] == 0) delete onefloor["equipment"];
      if (onefloor["seisisolator"]["value"][0] == 0 && onefloor["seisisolator"]["value"][1] == 0) delete onefloor["seisisolator"];
      athreshold.push(onefloor);
    }
    structure["stimulus"] = JSON.stringify(astimulus);
    structure["damage_threshold"] = JSON.stringify(athreshold);
    var value = await invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:updatesiteinformation", { sensor_id: props.point.id, alert: JSON.stringify(aalert), stimulus: structure["stimulus"], threshold: structure["damage_threshold"] });
    setAlert(aalert);
    setStructure(structure);
  }

  function getnumber(name) {
    var val = document.forms['edit'][name].value;
    if (val == "" || Number(val) == NaN) {
      return "";
    } else {
      return Number(val);
    }
  }

  function gettext(name) {
    return document.forms['edit'][name].value;
  }

  const handleSave = async () => {
    await save();
    window.alert("更新しました");
    props.update();
  };
  
  return (
    <>
      {floorcnt > 0 ?
        <div className={styles.body}>
          <div className={styles.header}>
            <div className={styles.title}>{props.point.name}</div>
            <div className={styles.discription}><div width='100%' /><div><button onClick={handleSave}>保存</button></div></div>
          </div>
          <div className={styles.container}>
            <form name="edit">
              <div className={styles.header}>
                <div className={styles.title}>アラート</div>
                <div className={styles.discription}>雨量、風速でアラートメールを飛ばさないときは空欄もしくは0を設定する</div>
              </div>
              <Alert />
              <div style={{ display: props.admin < 2 ? "none" : "" }}>
                <div className={styles.header}>
                  <div className={styles.title}>刺激関数</div>
                  <div className={styles.discription}>1フロア分の刺激関数はカンマ区切りで入力</div>
                </div>
                <Stimulas />
                <div className={styles.header}>
                  <div className={styles.title}>被災度判定閾値</div>
                  <div className={styles.discription}>1値で判断するときは同じ値を入力。判定しない項目は空欄。文面が空欄の時は「注意」「危険」が表示される。</div>
                </div>
                <Threshold />
              </div>
            </form>
          </div>
        </div>
        : <div>情報が登録されていません</div>}
    </>
  )
};